/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import SectionHeader from './SectionHeader';
import DuplicateTable from "./DuplicateReport/DuplicateTable";
import DocumentViewerModal from './DocumentViewerModal';

const DuplicateSection = ({
  title,
  columns,
  data,
  onTagPrimary,
  onMarkDuplicate,
  selectedRows,
  onRowSelect,
  actionLabel,
  showActions,
  emptyComponent,
}) => {
  const [internalSelected, setInternalSelected] = useState([]);
  const tableRef = useRef(null);

  const effectiveSelected = selectedRows ?? internalSelected;
  const effectiveSetSelected = onRowSelect ?? setInternalSelected;

  return (
    <>
      <SectionHeader
        title={title}
        hasSelection={effectiveSelected.length > 0}
        showActions={showActions}
        actionLabel={actionLabel}
        onAction={() => {
          onMarkDuplicate?.(effectiveSelected);
          effectiveSetSelected([]);
        }}
        tableRef={tableRef}
      />

      <div ref={tableRef}>
        <DuplicateTable
          title={title}
          columns={columns}
          data={data}
          pageSize={data.length}
          onTagPrimary={(row) => onTagPrimary?.(row)}
          onRowSelect={effectiveSetSelected}
          emptyComponent={emptyComponent}
        />
      </div>
    </>
  );
};

DuplicateSection.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onTagPrimary: PropTypes.func,
  onMarkDuplicate: PropTypes.func,
  selectedRows: PropTypes.array,
  onRowSelect: PropTypes.func,
};

export default DuplicateSection;
